<p-toast [baseZIndex]="5000"></p-toast>
<!-- Global Upload Status Component -->
<app-global-upload-status></app-global-upload-status>
<!-- <app-main-page></app-main-page> -->
<router-outlet></router-outlet>
<!-- GDPR / ePrivacy cookie-consent banner (shown until a choice is recorded) -->
<app-cookie-consent></app-cookie-consent>
<!-- Shared AI feedback reason dialog (EU AI Act / ISO 42001) -->
<app-ai-feedback-dialog></app-ai-feedback-dialog>

